'use client';

import * as React from 'react';
import { validateAdvancedColors } from '~theme/utils';
import { UIThemeProvider } from '~ui/theme/ThemeProvider';
import { AppBgColorProvider } from './AppBgColorContext/AppBgColorProvider';
import { CompanyStylesProvider } from './CompanyStylesContext/CompanyStylesProvider';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Main providers of the UI for the whole waiter app.
 */
export var UIProviders = function UIProviders(_ref) {
  var companyStyles = _ref.companyStyles,
      children = _ref.children;
  var advancedColors = React.useMemo(function () {
    return validateAdvancedColors(companyStyles.advancedStyles.colors);
  }, [companyStyles.advancedStyles.colors]);
  return /*#__PURE__*/_jsx(CompanyStylesProvider, {
    contextValue: companyStyles,
    children: /*#__PURE__*/_jsx(UIThemeProvider, {
      baseColors: companyStyles.colors,
      advancedColors: advancedColors,
      children: /*#__PURE__*/_jsx(AppBgColorProvider, {
        children: children
      })
    })
  });
};